<div class="promo-container">
  <div class="button-group">
    <button *ngIf="hasPromoEdit$ | async" mat-raised-button color="primary" (click)="submit()">{{ 'COMMON.APPLY' | translate }}</button>
    <button *ngIf="hasPromoEdit$ | async" mat-raised-button color="accent" (click)="editDishesList()">{{ 'MENU.PROMO.EDIT_LIST' | translate }}</button>
    <span *ngIf="loading" class="loading-indicator">
      {{ 'COMMON.LOADING' | translate }}
    </span>
  </div>
  <div class="dish-list" cdkDropList [cdkDropListDisabled]="(hasPromoEdit$ | async) !== true" (cdkDropListDropped)="dropProductGuarded($event)">
    <app-promo-product-card *ngFor="let product of products"
                            [product]="product"
                            [currentOrganization]="organization"
                             [cdkDragData]="product"
                             [cdkDragDisabled]="(hasPromoEdit$ | async) !== true"
                            cdkDrag
                            class="drag-box">
      <div *cdkDragPlaceholder class="product-drag-placeholder"></div>
    </app-promo-product-card>
  </div>
</div>
